// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1v0_N","header":"MessagesList_header__173rs","chat":"MessagesList_chat__1P4vu"};